import { Card, Row, Col, Typography, Divider, Tag, Space } from "antd";
import { CarOutlined, HeartOutlined } from "@ant-design/icons";

export const PetsAndVehicles = ({ applicants }: any) => {
  const petsArray = Array.from(
    new Map(
      (applicants?.flatMap((applicant: any) => applicant.pets || []) || []).map(
        (pet: any) => [pet.name?.trim().toLowerCase(), pet]
      )
    ).values()
  );

  const vehiclesArray = Array.from(
    new Map(
      (
        applicants?.flatMap((applicant: any) => applicant.vehicles || []) || []
      ).map((vehicle: any) => [vehicle.lic?.trim().toLowerCase(), vehicle])
    ).values()
  );

  return (
    <Row gutter={[16, 16]}>
      {petsArray?.length > 0 && (
        <Col xs={24}>
          <Card
            style={{
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "16px",
            }}
          >
            <Space align="center" style={{ marginBottom: 12 }}>
              <HeartOutlined style={{ fontSize: 20, color: "#fa8c16" }} />
              <Typography.Text strong style={{ fontSize: 16 }}>
                Pets ({petsArray.length})
              </Typography.Text>
            </Space>
            <Divider style={{ margin: "12px 0" }} />
            {petsArray.map((pet: any, index: number) => (
              <div key={index} style={{ marginBottom: 8 }}>
                <Typography.Text strong>{pet.name}</Typography.Text>
                <Typography.Text type="secondary" style={{ marginLeft: 8 }}>
                  {pet.breed} {pet.type} • {pet.color} • {pet.weight}lbs •{" "}
                  {pet.age} years
                  {pet.neutered && (
                    <Tag color="success" style={{ marginLeft: 8 }}>
                      Neutered
                    </Tag>
                  )}
                </Typography.Text>
              </div>
            ))}
          </Card>
        </Col>
      )}
      {vehiclesArray?.length > 0 && (
        <Col xs={24}>
          <Card
            style={{
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "16px",
              marginBottom: 16,
            }}
          >
            <Space align="center" style={{ marginBottom: 12 }}>
              <CarOutlined style={{ fontSize: 20, color: "#722ed1" }} />
              <Typography.Text strong style={{ fontSize: 16 }}>
                Vehicles ({vehiclesArray.length})
              </Typography.Text>
            </Space>
            <Divider style={{ margin: "12px 0" }} />
            {vehiclesArray.map((vehicle: any, index: number) => (
              <div key={index} style={{ marginBottom: 8 }}>
                <Typography.Text strong>
                  {vehicle.year} {vehicle.make} {vehicle.model}
                </Typography.Text>
                <Typography.Text type="secondary" style={{ marginLeft: 8 }}>
                  {vehicle.color} • License: {vehicle.lic}
                  {vehicle.insurance_company && (
                    <Tag color="blue" style={{ marginLeft: 8 }}>
                      {vehicle.insurance_company}
                    </Tag>
                  )}
                </Typography.Text>
              </div>
            ))}
          </Card>
        </Col>
      )}
    </Row>
  );
};
